import { createSelector } from 'reselect';

import { StateType } from '../../index';

export const userProfileReducerSelector = (state: StateType) => state.getIn(['profile', 'user']);
export const userProfileIsFetchingUserReducerSelector = (state: StateType) => state.getIn(['profile', 'user', 'isFetching']);
export const userProfileInvalidUserSelector = (state: StateType) => state.getIn(['profile', 'user', 'invalidUser']);
export const userProfileAchievementsSelector = (state: StateType) => state.getIn(['profile', 'user', 'achievements']);
export const userProfileCompetitionsSelector = (state: StateType) => state.getIn(['profile', 'user', 'competitions']);
export const userProfileDataIdSelector = (state: StateType) => state.getIn(['profile', 'user', 'data', 'id']);
export const userProfilePerformanceLeaderboardSelector = (state: StateType) => state.getIn(['profile', 'performance', 'leaderboard']);

export const consultantPerformanceLeaderboardSelector = (state: StateType) => state.getIn(['consultant', 'data', 'leaderboard']);
export const userProfilePerformanceLeaderboardActualWeightRankSelector = (state: StateType) =>
  state.getIn(['profile', 'performance', 'leaderboard', 'actualWeightRank']) as number | null;

export const userProfileAchievedSelector = createSelector(
  userProfileAchievementsSelector,
  // @ts-ignore
  achievementsArray => achievementsArray.filter((item: any) => item.get('achieved') !== null)
);
